import { AxiomLogger } from "./forwarders/axiom-logger";
import { ConsoleLogger } from "./forwarders/console-logger";
import { VoidLogger } from "./forwarders/void-logger";
import { LogRouter } from "./log-router";
import { type ILogForwarder, LogLevel } from "./types";

export { logger, SetDefaultLogger } from "./default-logger";

export function GetLogger(
	env: "develop" | "production" | "uat" | "staging",
	project: string,
	axiomToken: string,
	axiomOrgId: string,
	axiomDataset: string,
	logLevel: LogLevel = LogLevel.trace,
): LogRouter {
	let trivialLogger: ILogForwarder;
	let axiomLogger: ILogForwarder;

	if (env === "develop") {
		trivialLogger = new ConsoleLogger();
		axiomLogger = new ConsoleLogger();
	} else if (env === "production") {
		trivialLogger = new VoidLogger();
		axiomLogger = new AxiomLogger(axiomToken, axiomOrgId, axiomDataset);
	} else {
		trivialLogger = new ConsoleLogger();
		axiomLogger = new AxiomLogger(axiomToken, axiomOrgId, axiomDataset);
	}

	const logRouter = new LogRouter(logLevel, axiomLogger, trivialLogger);
	logRouter.injectCommonProp("project", project);
	return logRouter;
}

export { AxiomLogger } from "./forwarders/axiom-logger";
export { ConsoleLogger } from "./forwarders/console-logger";
export { TeeLogger } from "./forwarders/tee-logger";
export { VoidLogger } from "./forwarders/void-logger";
export { LogRouter } from "./log-router";
export * from "./types";
export {
	type ErrorIdentity,
	errorIdentityOf,
	errorMessageOf,
	errorNameOf,
	messageOnlyErrorIdentityOf,
} from "./utils/error-name";
export { formatEventMessage } from "./utils/event-message";
export { normalizeLogValue } from "./utils/normalize";
export * from "./utils/time-logger";
